"use client";

import * as React from "react";
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";

import { cn } from "@/lib/utils";

interface CommandSidebarScrollAreaProps {
    className?: string;
    children: React.ReactNode;
}

export function CommandSidebarScrollArea({
    className,
    children,
}: CommandSidebarScrollAreaProps) {
    return (
        <ScrollAreaPrimitive.Root
            type="scroll"
            scrollHideDelay={600}
            className={cn(
                "relative min-h-0 flex-1 overflow-hidden",
                className
            )}
        >
            <ScrollAreaPrimitive.Viewport className="h-full w-full [&>div]:!block [&>div]:!min-w-0">
                {children}
            </ScrollAreaPrimitive.Viewport>
            <ScrollAreaPrimitive.ScrollAreaScrollbar
                orientation="vertical"
                className="flex w-2 touch-none select-none border-l border-l-transparent p-px opacity-0 transition-opacity duration-200 data-[state=visible]:opacity-100"
            >
                <ScrollAreaPrimitive.ScrollAreaThumb className="relative flex-1 rounded-full bg-border/70" />
            </ScrollAreaPrimitive.ScrollAreaScrollbar>
            <ScrollAreaPrimitive.Corner />
        </ScrollAreaPrimitive.Root>
    );
}
